import React, {useRef} from "react";
import {AButton} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import {t} from "i18next";
import {useSelector} from "react-redux";
import {
  selectAllowSaveInvestigation,
  selectInvestigationDetailId,
  selectInvestigationShortId
} from "store/selectors/investigationSelectors";
import SaveInvestigationModal from "./SaveInvestigationModal";
import css from "./InvestigateDetailHeader.module.scss";

// @todo Get title for saved
const InvestigateDetailHeader = ({className}) => {
  const ref = useRef();

  const investigationId = useSelector(selectInvestigationDetailId);
  const investigationShortDescription = useSelector(selectInvestigationShortId);
  const allowSaveInvestigation = useSelector(selectAllowSaveInvestigation);

  const handleSaveInvestigationClick = () => {
    ref.current?.openModal();
  };

  return (
    <>
      {/** Header Content */}
      <div
        className={classNames(
          "d-flex flex-row flex-nowrap justify-space-between align-center",
          className
        )}
        data-testid={"InvestigationDetail-PanelTitle"}>
        {/* @todo Replace id with actual Investigation Title/Summary */}

        <h1 className={css.title}>
          {investigationShortDescription
            ? investigationShortDescription
            : investigationId}
        </h1>

        <AButton
          primary
          medium
          onClick={handleSaveInvestigationClick}
          disabled={!allowSaveInvestigation}>
          {t("investigationDetail.save.saveInvestigationBtn")}
        </AButton>
      </div>

      {/** Save Investigation Modal */}
      <SaveInvestigationModal ref={ref} />
    </>
  );
};

export default InvestigateDetailHeader;
